import {createTheme} from '@material-ui/core/styles'

export default theme = createTheme(
	typography:
		fontFamily: [
			'din'
			'Roboto'
		]
	palette:
		primary: main:'#fac40b'
)
